module.exports = __webpack_public_path__ + "static/media/Sceptile_gaussian2.fd3e6d84.png";